export enum SenderSource {
  USER = "user",
  SYSTEM = "system",
  AGENT = "agent",
  INFO = "info"
}
